// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d855a71b","779":"e88b6381","935":"e979f22c"}[chunkId] + ".chunk.js";
};